<template>
    <header class="header" >
    <div class="container">
        <div class="row">
        <div class="span3 logo-box" style="position:absolute;">
            <router-link to="/home" class="logo">
            <img src="img/logo.png" class="logo-img" alt="" style="height:100px">
            </router-link>
        </div>
        <div class="span7 primary menu-header" style="">
            <div class="navbar">
            <a class="btn btn-navbar collapsed btn-menu" data-toggle="collapse" data-target=".primary .nav-collapse">
                <span class="text"></span>
                <span class="icon-bar"></span>
                <span class="icon-bar"></span>
                <span class="icon-bar"></span>
            </a>
            <nav class="nav-collapse collapse">
                <ul class="nav">
                <li class="">
                    <router-link to="/">Home</router-link>
                </li>
                <li v-for="(result,index) in AllCategories" :key="result.id">
                    <router-link v-if="index<3" :to="'/' + result.page_name">{{result.title}}</router-link>
                </li>
                <li class="parent" v-if="AllCategories.length >=3">
                    <router-link to="#">More</router-link>
                    <ul class="sub">
                        <li v-for="(result,index) in AllCategories" :key="result.id" ><router-link v-if="index>=3" :to="'/' + result.page_name">{{result.title}}</router-link></li>
                    </ul>
                </li>
                </ul>
            </nav>
            </div>
        </div><!-- .primary -->
        
        <div class="MenuRightDropDown span2 pull-right dropdown-header" style="">
            <div class="btn-group cart-header">
            <a href="#" class="dropdown-toggle" data-toggle="dropdown" style="color:#551315;">
                <div class="icon">
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                width="16px" height="16px" viewBox="0 0 16 16" enable-background="new 0 0 16 16" xml:space="preserve">
                    <g>
                    <path fill="#1e1e1e" d="M15.001,4h-0.57l-3.707-3.707c-0.391-0.391-1.023-0.391-1.414,0c-0.391,0.391-0.391,1.023,0,1.414L11.603,4
                    H4.43l2.293-2.293c0.391-0.391,0.391-1.023,0-1.414s-1.023-0.391-1.414,0L1.602,4H1C0.448,4,0,4.448,0,5s0.448,1,1,1
                    c0,2.69,0,7.23,0,8c0,1.104,0.896,2,2,2h10c1.104,0,2-0.896,2-2c0-0.77,0-5.31,0-8c0.553,0,1-0.448,1-1S15.554,4,15.001,4z
                    M13.001,14H3V6h10V14z"/>
                    <path fill="#231F20" d="M11.001,13c0.553,0,1-0.447,1-1V8c0-0.553-0.447-1-1-1s-1,0.447-1,1v4C10.001,12.553,10.448,13,11.001,13z"/>
                    <path fill="#231F20" d="M8,13c0.553,0,1-0.447,1-1V8c0-0.553-0.448-1-1-1S7,7.447,7,8v4C7,12.553,7.448,13,8,13z"/>
                    <path fill="#231F20" d="M5,13c0.553,0,1-0.447,1-1V8c0-0.553-0.447-1-1-1S4,7.447,4,8v4C4,12.553,4.448,13,5,13z"/>
                </g>
                </svg>
                </div>
                Cart <span id="divcart_item">{{ CartCount }}</span>
                
            </a>
            <div class="dropdown-menu">
                <strong>Recently added item(s)</strong>
                <ul class="unstyled">
                <li v-for="(item,index) in Cart" :key="index">
                    
                    <router-link :to="'#/' + item.cpage_name +'/'+ item.page_name" class="product-image"><img :src="item.image_path" width="70" height="70" alt=""></router-link>
                    <a href="javascript:;" v-on:click="removeFromCart(item)" class="product-remove">
                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                    width="16px" height="16px" viewBox="0 0 16 16" enable-background="new 0 0 16 16" xml:space="preserve">
                        <g>
                        <path fill="#7f7f7f" d="M6,13c0.553,0,1-0.447,1-1V7c0-0.553-0.447-1-1-1S5,6.447,5,7v5C5,12.553,5.447,13,6,13z"/>
                        <path fill="#7f7f7f" d="M10,13c0.553,0,1-0.447,1-1V7c0-0.553-0.447-1-1-1S9,6.447,9,7v5C9,12.553,9.447,13,10,13z"/>
                        <path fill="#7f7f7f" d="M14,3h-1V1c0-0.552-0.447-1-1-1H4C3.448,0,3,0.448,3,1v2H2C1.447,3,1,3.447,1,4s0.447,1,1,1
                        c0,0.273,0,8.727,0,9c0,1.104,0.896,2,2,2h8c1.104,0,2-0.896,2-2c0-0.273,0-8.727,0-9c0.553,0,1-0.447,1-1S14.553,3,14,3z M5,2h6v1
                        H5V2z M12,14H4V5h8V14z"/>
                        </g>
                    </svg>
                    </a><!-- .product-remove -->
                    <h4 class="product-name"><router-link :to="'/' + item.cpage_name +'/'+ item.page_name" title="">{{item.title}} <br> [Wt: {{item.weight}} <span v-if="item.size != ''">, Size: {{item.size}}</span>] </router-link></h4>
                    <div class="product-price">Pcs: {{item.qty}}</div>
                    <div class="clearfix"></div>
                </li>
                <li><div class="product-price pull-left" style="margin-left:-80px;">Item(s): {{Cart.length}}</div>
                    <div class="product-price pull-right"><strong>Total Weight: {{CountTotalWeight()}}</strong></div>
                    <br>
                </li>
                </ul>
                <div class="cart-button">
                <button v-on:click="$router.push('/cart')" class="btn">View Cart</button>
                <button v-if="Session.is_login" v-on:click="$router.push('/checkout')" class="btn checkout">Checkout</button>
                <button v-if="!Session.is_login" v-on:click="$router.push('/login/?f=checkout')" class="btn checkout">Checkout</button>
                </div>
            </div>
            </div><!-- .cart-header -->

            <div class="cart-header">
            <a href="#" class="dropdown-toggle" data-toggle="dropdown" style="color:#551315;">
            <div class="icon">
                <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 1000 1000" enable-background="new 0 0 1000 1000" xml:space="preserve">
                <g><path d="M602.4,558.7H397.6C222.2,558.7,80,708.5,80,892.9v21.5c0,75.5,142.1,75.6,317.6,75.6h204.9c175.3,0,317.6-2.8,317.6-75.6v-21.5C920,708.5,777.8,558.7,602.4,558.7L602.4,558.7z M251.9,264.8c0-33.4,6.4-66.7,18.9-97.5c12.4-30.8,30.8-59.1,53.8-82.6C347.5,61,375,42.1,405,29.4c30-12.8,62.5-19.4,95-19.4c32.5,0,64.9,6.6,95,19.4c30,12.7,57.5,31.6,80.5,55.2c23,23.6,41.3,51.8,53.8,82.6c12.4,30.8,18.9,64.2,18.9,97.5s-6.4,66.7-18.9,97.5c-12.4,30.8-30.8,59.1-53.8,82.6c-23,23.6-50.5,42.5-80.5,55.2c-30,12.8-62.5,19.4-95,19.4c-32.5,0-64.9-6.7-95-19.4c-30-12.8-57.5-31.6-80.5-55.2c-23-23.5-41.3-51.8-53.8-82.6C258.3,331.4,251.9,298.1,251.9,264.8L251.9,264.8z"/></g>
                </svg>
            </div>
                Account
            </a>
            <div class="dropdown-menu">
                <ul class="unstyled" style="color:#551315;">
                <strong v-if="Session.is_login">{{Session.first_name + " " + Session.last_name}}</strong>		
                
                <li> Welcome to our shopping cart !</li>
            
                </ul>
                <div class="cart-button">
                    <button v-if="Session.is_login" type="button" class="btn" v-on:click="$router.push('/account')">My Account</button>
                    <button v-if="Session.is_login" type="button" class="btn checkout" v-on:click="Logout">Logout</button>
                    <button v-if="!Session.is_login" type="button" class="btn" v-on:click="$router.push('/create-account')">Sign-up</button>
                    <button v-if="!Session.is_login" type="button" class="btn checkout" v-on:click="$router.push('/login')">Sign-in</button>

                    <input type="hidden" id="vc_pid" name="vc_pid" />
                </div>
            </div>
            </div>
        </div>
        
        </div><!--.row -->
    </div>
    </header>
</template>
<script>
import {mapGetters, mapActions} from "vuex";
import $ from 'jquery';
//import EventBus from '@/EventBus.js'
import Common from '@/common.js'
import Authentication from '@/authentication.js';

export default {
  name: 'Header',
  props: {
    msg: String
  },data: function(){
    return {
       results: {'categories':{},'cart':{},'cart_count':'0','session':{"is_login": false,"user_id": 0,"user_name":"","company_name": "","first_name": "","last_name": "","user_type": ""}}
     }
    }
  ,mounted: function() {
    this.loadSessionValues();
    
    //alert(JSON.stringify(mapGetters))
    //Common.callServerFunction("Items/ItemController::GetCategory",this.get_response,{},"Item");
    //this.results.categories = this.$store.state.categories;
    //console.log('--------------------');
    //console.log(this.$store.state.categories);
    //console.log('--------------------');

    //this.setCartItemCount(0);
    //Common.callServerFunction("empty_cart",this.response_cart,{},null);
    //Common.callServerFunction("Cart/CartController::GetCartCount",this.response_cart,{},null);
    //Common.callServerFunction("Cart/CartController::GetCartItems",this.response_cart_items,{},"View Cart");
    //Common.callServerFunction("Users/UserController::LoginSession",this.get_session_response,this.results,"Users");
            
    //EventBus.$on('cart_count',function(item_count){
    //    $("#divcart_item").html(item_count);
    //});
    
  },
  computed:mapGetters(["Session","Cart","CartCount","AllCategories"]),
      watch:{
      AllCategories(newValue) { this.get_response(newValue)  },
      Session(newValue) { this.get_session_response(newValue)  },
      Cart(newValue) { this.response_cart_items(newValue)  },
      CartCount(newValue) { this.results.cart_count = newValue  },
    },
  methods:{

      ...mapActions(["removeFromCart","getCart","getSession","logoutSession"]),
      HeaderStyle(){
          var style = null;
          if(this.isMobile())
          {
              style = {'padding':'5px 10px 1px'};
              $(".header").addClass('border-bottom');
              $(".MenuRightDropDown").attr("style","margin-top:-9px;padding-right:5px")
          }else
          {
              style = {'padding':'23px 10px 23px'}
              $(".header").removeClass('border-bottom');
              $("#topRighLink").removeClass('hide');
          }
        return style;
      },
      isMobile:function(){
         return Common.isMobile();
      },      
      Logout:function()
      {
              this.logoutSession();
              this.$router.push("/login");
      },
      loadSessionValues:function()
      {
          this.get_response(this.AllCategories);
          this.get_session_response(this.Selection);
          this.response_cart_items(this.Cart);
          this.results.cart_count = this.CartCount;
      },CountTotalWeight:function()
        {
          var total_weight = 0;
          if(this.Cart.length > 0){
                this.Cart.forEach((item) => {
                   total_weight = parseFloat(total_weight) + parseFloat(item.weight);
                });
          }
          return total_weight;
        },
      get_response:function(response)
      {  
          //var rdata = JSON.parse(response);
          var rdata = response;
          this.results.categories = rdata;
          //this.$store.dispatch("setSession", rdata);
      },
      get_session_response:function(response)
    {	
    //var rdata = JSON.parse(response);
    var rdata = response;
    this.results.session = rdata;
    //Authentication.setSession(rdata);
    Authentication.session = rdata;

    //this.$store.dispatch("setSession", rdata);

    //EventBus.$emit('set_session', rdata);
    Common.stopAjaxLoader();
    },
    response_cart_items:function(response)
    {
        //console.log(response);
        //var rdata1 = {"cartTotal":0,"PanelTitle":title,"Rows":JSON.parse(response)}
        var rdata1 = response;
        this.results.cart = rdata1;
        Common.stopAjaxLoader();
    },
    response_cart:function(response)
    {
        //alert(response);
        var rdata = JSON.parse(response);
        this.results.cart_count = rdata.cart_count;
        //this.setCartItemCount(rdata.cart_count);
    }
    //,RemoveFromCart:function(e,id)
    //{
    //    //Common.callServerFunction("Cart/CartController::RemoveFromCart",this.response_cart_items,{'pid':id},"View Cart");
    //}
    //,setCartItemCount:function(item_count)
    //{
    //    //$("#divcart_item").html(item_count);
    //}
}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>